import React, { useEffect } from 'react';
import Header from '../components/Header';
import PrivacyPolicy from '../components/PrivacyPolicy';
import Footer from '../components/Footer';
import { initSEO } from '../seo';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    initSEO('privacy');
  }, []);

  return (
    <>
      <Header />
      <PrivacyPolicy />
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
